import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import NewHeader from "../Header/NewHeader";
import NewFooter from "../Footer/NewFooter";
import { motion } from "framer-motion";
import { FaPlay } from "react-icons/fa";

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const sectionsRef = useRef([]);

  const desktopCarouselRef = useRef(null);
  const mobileCarouselRef = useRef(null);
  const sectionsRef1 = useRef([]);

  const registerPanel = (el) => {
    if (el && !sectionsRef1.current.includes(el)) {
      sectionsRef1.current.push(el);
    }
  };

  useEffect(() => {
    const initCarousel = () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());

      const refToUse =
        window.innerWidth >= 1024 ? desktopCarouselRef : mobileCarouselRef;
      if (!refToUse.current) return;

      const sections = gsap.utils.toArray(".panel", refToUse.current);

      const horizontalTween = gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: refToUse.current,
          pin: true,
          start: "top top",
          end: () =>
            "+=" + refToUse.current.offsetWidth * (sections.length - 1),
          scrub: 1.2,
          snap: 1 / (sections.length - 1),
        },
      });

      sectionsRef1.current.forEach((section) => {
        const elements = section.querySelectorAll("h2, p");

        gsap.fromTo(
          elements,
          {
            x: 150,
            opacity: 0,
          },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.3,
            ease: "power3.out",
            scrollTrigger: {
              containerAnimation: horizontalTween,
              trigger: section,
              start: "left center",
              end: "right center",
              scrub: false,
              toggleActions: "play reverse play reverse",
            },
          }
        );
      });

      ScrollTrigger.refresh();
    };

    initCarousel();
    window.addEventListener("resize", initCarousel);
    return () => window.removeEventListener("resize", initCarousel);
  }, []);

  // useEffect(() => {
  //   const initCarousel = () => {
  //     ScrollTrigger.getAll().forEach((t) => t.kill());

  //     const refToUse =
  //       window.innerWidth >= 1024 ? desktopCarouselRef : mobileCarouselRef;
  //     if (!refToUse.current) return;

  //     const sections = gsap.utils.toArray(".panel", refToUse.current);

  //     const horizontalTween = gsap.to(sections, {
  //       xPercent: -100 * (sections.length - 1),
  //       ease: "none",
  //       scrollTrigger: {
  //         trigger: refToUse.current,
  //         pin: true,
  //         scrub: 0.5,
  //         snap: 1 / (sections.length - 1),

  //         end: () =>
  //           "+=" + refToUse.current.offsetWidth * (sections.length - 1),
  //       },
  //     });

  //     sectionsRef1.current.forEach((section) => {
  //       const elements = section.querySelectorAll("h2, p");

  //       gsap.fromTo(
  //         elements,
  //         {
  //           x: 150,
  //           opacity: 0,
  //         },
  //         {
  //           x: 0,
  //           opacity: 1,
  //           duration: 1,
  //           stagger: 0.3,
  //           ease: "power3.out",
  //           scrollTrigger: {
  //             containerAnimation: horizontalTween,
  //             trigger: section,
  //             start: "left center",
  //             end: "right center",
  //             scrub: false,
  //           },
  //         }
  //       );
  //     });

  //     ScrollTrigger.refresh();
  //   };

  //   initCarousel();
  //   window.addEventListener("resize", initCarousel);
  //   return () => window.removeEventListener("resize", initCarousel);
  // }, []);

  // all
  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  // useEffect(() => {
  //   sectionsRef.current.forEach((section) => {
  //     const texts = section.querySelectorAll("h2, p");
  //     const images = section.querySelectorAll("img");

  //     // Detect if mobile
  //     const isMobile = window.innerWidth < 1024;

  //     // Text animation
  //     gsap.fromTo(
  //       texts,
  //       { opacity: 0, y: 50 },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: isMobile ? 0.8 : 1, // slightly faster on mobile
  //         stagger: 0.2,
  //         ease: "power3.out",
  //         scrollTrigger: {
  //           trigger: section,
  //           start: "top 90%", // mobile: start slightly later
  //           end: "bottom 20%",
  //           toggleActions: "play none none reverse",
  //         },
  //       }
  //     );

  //     // Image animation
  //     gsap.fromTo(
  //       images,
  //       { opacity: 0, y: 80 },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: isMobile ? 0 : 2,
  //         stagger: 0.2,
  //         ease: "power3.out",
  //         scrollTrigger: {
  //           trigger: section,
  //           start: "top 90%",
  //           end: "bottom 20%",
  //           toggleActions: "play none none reverse",
  //         },
  //       }
  //     );
  //   });

  //   ScrollTrigger.refresh();
  // }, []);

  //========

  useEffect(() => {
    const isMobile = window.innerWidth < 768;

    sectionsRef.current.forEach((section) => {
      const texts = section.querySelectorAll("p, h2");
      if (texts.length === 0) return;

      if (isMobile) {
        texts.forEach((t) => {
          t.style.opacity = "1";
          t.style.transform = "translateY(0)";
        });
        return;
      }

      // DESKTOP
      gsap.fromTo(
        texts,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }, []);

  //================================================
  // useEffect(() => {
  //   sectionsRef.current.forEach((section) => {
  //     const texts = section.querySelectorAll("p, h2");

  //     gsap.fromTo(
  //       texts,
  //       { opacity: 0, y: 50 },
  //       {
  //         opacity: 1,
  //         y: 0,
  //         duration: 1,
  //         stagger: 0.3,
  //         ease: "power2.out",
  //         scrollTrigger: {
  //           trigger: section,
  //           start: "top 80%",
  //           toggleActions: "play none none none",
  //         },
  //       }
  //     );

  //     const images = section.querySelectorAll("img");

  //     images.forEach((img) => {
  //       gsap.fromTo(
  //         img,
  //         { opacity: 0, y: 50 },
  //         {
  //           opacity: 1,
  //           y: 0,
  //           duration: 0.1,
  //           ease: "power2.out",
  //           scrollTrigger: {
  //             trigger: img,
  //             start: "top 85%",
  //             toggleActions: "play none none none",
  //           },
  //         }
  //       );
  //     });
  //   });
  // }, []);
  //================

  return (
    <div className="relative w-full overflow-hidden">
      {/* ------------------ DESKTOP SECTION 1 ------------------ */}
      <div
        className="hidden lg:flex fixed top-0 left-0 w-full h-screen flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d5f647fd-2d2f-438b-7aef-2d1ff65bf700/public')`, // Tao_Homebanner.webp
        }}
      >
        <div className="relative z-10 flex flex-col items-center justify-center text-center text-[#F5F2F0]">
          <img
            src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/83b28aec-0ca2-4344-32a0-bee3d7db0400/public" // tao_logo_full.png
            alt="House of Tao"
            className="w-[200px] lg:w-[130px] mt-2 animate-zoom-in"
          />
        </div>
        <p className="absolute bottom-7 text-[13px] tracking-[0.20em] uppercase text-[#f5f5f0] z-10 text-center opacity-0 animate-slide-up">
          WELCOME HOME, TO YOURSELF
        </p>
      </div>
      <style jsx global>{`
        @keyframes zoomInGrow {
          0% {
            opacity: 0;
            transform: scale(0.7);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-zoom-in {
          animation: zoomInGrow 1.2s ease-out forwards;
        }
      `}</style>

      {/* ------------------ DESKTOP SECTION 2 ------------------ */}
      <div
        id="section2"
        className="hidden lg:grid relative mt-[110vh] z-10 w-full bg-[#f5f2f0] pb-5 2xl:-mb-1 grid-cols-[2fr_1fr]"
      >
        <div className="relative w-[85%] lg:w-[110%] h-[100vh] overflow-hidden">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
            alt="Living Room"
            className="object-cover w-full h-full"
          />
        </div>
        <div
          ref={addToRefs}
          className="flex items-end justify-end px-8 sm:px-12 lg:px-16 py-10 2xl:py-20"
        >
          <div className="text-[#948A78] leading-[1.9]  tracking-wide text-right space-y-2 mb-1 text-[13px] 2xl:translate-y-6">
            <p>
              A space to pause, <br /> to feel the wind move <br /> through
              arches, <br /> to watch the light <br /> fall without urgency.
            </p>
            <p>
              Rooted in Taoist principles <br /> of balance and presence, <br />{" "}
              our home is crafted to <br /> help you return to yours — <br />{" "}
              the one within.
            </p>
            <p>
              Come as you are. <br /> Leave a little lighter.
            </p>
          </div>
        </div>
      </div>

      <div className="hidden lg:block">
        <NewHeader />
      </div>

      {/* section 3 */}
      <div
        ref={addToRefs}
        className="hidden lg:flex relative z-10 w-full items-center justify-between -mt-1 py-16 px-6 md:px-10 bg-[#f5f2f0]"
      >
        <div className="w-full md:w-1/2 flex justify-start mb-8 md:mb-6 -mt-10">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/07f16891-b0d9-4bc3-4a33-74c470751000/public" //Tao_home_3.webp
            alt="Philosophy"
            className=" lg:w-[90%] xl:w-[85%] 2xl:w-[90%] 4k:w-[100%] h-auto object-cover"
          />
        </div>

        <div className="md:w-1/2 text-[#948A78] leading-[1.9] tracking-wide space-y-3 md:pl-12 text-left relative">
          <div className="flex justify-end pr-[85%] 4k:pl-96">
            <h2 className="text-[20px]  text-[#948A78] text-right leading-snug mb-0">
              Our <br /> Philosophy
            </h2>
          </div>
          <div className="flex flex-col items-end pr-[2%] space-y-2 text-[13px] lg:ml-[70px] xl:ml-[65px] 2xl:ml-[120px] 4k:ml-[380px] w-[350px]">
            <p>
              House of Tao is designed to help you disconnect from noise and
              reconnect with what matters: nature, rest, and self.
            </p>
            <p>
              We follow Taoist principles: living in alignment with the natural
              world, choosing presence over pace and embracing the simple beauty
              of each moment.
            </p>
            <p>
              From the outside, it’s quiet and grounded. But step in and you’ll
              feel something shift — not because of grand gestures or luxury for
              luxury’s sake, but because every corner has been thought through.
            </p>
            <p>
              Here, beauty is not about perfection. It’s about presence — in the
              way light moves through a room, in how time begins to stretch, in
              how you begin to return to yourself.
            </p>
            <div className="lg:h-5 xl:h-12 2xl:h-16 4k:h-16"></div>
            <div className="flex justify-between items-center w-full max-w-[350px]">
              <p className="text-right text-[13px] lg:mb-10">
                Welcome home. To yourself.
              </p>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex w-full md:w-1/2 justify-end -mt-96 mb-6 -mr-2 ml-4">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
            alt="Philosophy1"
            className="shadow-lg lg:w-[95%] xl:w-[80%] 2xl:w-[75%] 4k:w-[85%] h-auto object-cover"
          />
        </div>

        <div className="absolute bottom-28 right-[3%] xl:right-[2%] 2xl:right-[12%] 4k:right-[2%] text-[13px] z-50">
          <div className="flex items-center space-x-12 text-[#948A78]">
            <a href="/OurPhilosophy">
              <p className="text-[13px] tracking-widest uppercase cursor-pointer hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
                Learn more
              </p>
            </a>
          </div>
        </div>
      </div>

      {/* ------------------ DESKTOP SECTION 4 ------------------ */}
      <div className="hidden lg:flex relative w-full flex-col-reverse md:flex-row items-end justify-between -mt-10 -mb-1 bg-[#f5f2f0] py-0 md:py-1 px-6 md:px-10 pb-20">
        <div className="w-full md:w-2/3 flex justify-center md:justify-start md:order-1 order-2">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e8195ab7-4494-4280-534c-cf52841a6d00/public" //Tao_home_5.webp
            alt="Modern Architecture"
            className="w-full lg:max-w-[700px] xl:max-w-[910px] 2xl:max-w-[900vh] 3xl:max-w-[1000vh] 4k:max-w-[1300vh] h-auto object-cover rounded-none transition-all duration-500"
          />
        </div>

        <div
          ref={addToRefs}
          className="w-full md:w-1/3 flex justify-center md:justify-end mt-6 md:mt-0 md:order-2 order-1"
        >
          <div className="text-[#948A78] text-[13px] leading-relaxed text-left  tracking-wide md:ml-10 md:mb-10">
            <p>
              We started with a sense of balance, ease, and how we wanted people
              to show up. The purpose of House of Tao is to help you detach from
              the outside world and re-establish a connection with nature,
              relaxation, and yourself.
            </p>
          </div>
        </div>
      </div>

      {/* ------------------ DESKTOP CAROUSEL ------------------ */}
      <div
        className="hidden lg:flex w-full h-screen overflow-hidden bg-[#f5f2f0]"
        ref={desktopCarouselRef}
      >
        {/* -------- PANEL 1 -------- */}
        <section
          ref={registerPanel}
          className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -mr-1"
        >
          <div
            className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
          >
            <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
              <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
                  alt="Living Room"
                  className="
                       lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
                       lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
                      object-cover shadow-lg transition-all duration-300"
                />
                <div
                  className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                  >
                    <path
                      d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                      stroke="#948A78"
                      stroke-width="1.0"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>

              <div
                className="lg:w-[98%] xl:w-[90%] 2xl:w-[520px] 4k:w-[550px]
                            text-[13px]
                            leading-relaxed  tracking-wide text-[#948A78]"
              >
                <p className="mb-4">
                  This space is designed for pause. <br />
                  For conversation. <br />
                  For silence. <br />
                  For everything in between.
                </p>
                <p className="mb-4">
                  One seating is a deep, sectional sofa, perfect for long hours
                  and even longer conversations. Another faces the TV, for easy,
                  familiar comfort. In one corner, a round window offers a cozy
                  reading spot.
                </p>
                <p className="mb-4">
                  There’s also a small bar tucked into the space, ideal for an
                  evening drink.
                </p>
              </div>
            </div>

            <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
              <div
                className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto 
                            px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24 
                            mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
              >
                <div className="flex flex-col justify-center items-start  space-y-4">
                  <div className="text-right -ml-32">
                    <h2
                      className="text-[20px]  
                                  text-[#948A78] leading-snug mb-0 "
                    >
                      The Space at <br /> a Glance.
                    </h2>
                  </div>

                  <div
                    className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                                text-[13px]
                                leading-relaxed  tracking-wide text-[#948A78]"
                  >
                    <p className="mb-0 mt-0">
                      A 5-bedroom home with ensuite baths, vaulted living,
                      sun-washed courtyards, a private pool, and an open-sky
                      jacuzzi — designed for connection and calm.
                    </p>
                  </div>
                  <div>
                    <Link to="/OurSpaces">
                      <span
                        className="relative inline-block  tracking-widest uppercase cursor-pointer 
                                text-[#948A78] text-[13px]
                                hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                      >
                        OUR SPACES
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                <div className="flex justify-end items-center mb-6 lg:mb-2">
                  <span
                    className="tracking-widest uppercase text-[#948A78] 
                      text-[13px]"
                  >
                    THE LIVING ROOM
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                  >
                    <path
                      d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                      stroke="#948A78"
                      strokeWidth="1.5"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                  <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80626821-ded1-416c-b3ce-80561ba7f300/public" //Tao_home_7.webp
                          alt="living Detail 1"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
                          alt="living Detail 2"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* -------- PANEL 2 -------- */}
        <section
          ref={registerPanel}
          className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -mr-1"
        >
          <div
            className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
          >
            <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
              <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5ae81ca8-28ab-4902-84c6-bd0f6dd4c900/public" //Tao_home_9.webp
                  alt="Living Room"
                  className="
                       lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
                       lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
                      object-cover shadow-lg transition-all duration-300"
                />
                <div
                  className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                  >
                    <path
                      d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                      stroke="#948A78"
                      stroke-width="1.0"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>

              <div
                className="lg:w-[98%] xl:w-[70%] 2xl:w-[520px] 4k:w-[550px]
                            text-[13px]
                            leading-relaxed  tracking-wide text-[#948A78]"
              >
                <p className="mb-4">
                  The dining space brings people together, it seats 14 with ease
                  and opens straight onto the verandah, so the breeze flows in
                  without asking.
                </p>
                <p className="mb-4">
                  The light above the table isn’t grand, but it’s quietly
                  special, made with layered fabric, stitched by a local tailor
                  who understood what we were trying to create.
                </p>
                <p className="mb-4">
                  When the wind moves through, the light shifts just a little.
                  It’s a space that feels open, gentle and lived in. Meals here
                  tend to stretch longer than planned and that’s exactly how we
                  like it.
                </p>
              </div>
            </div>

            <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
              <div
                className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto 
                            px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24 
                            mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
              >
                <div className="flex flex-col justify-center items-start  space-y-4">
                  <div className="text-right -ml-32">
                    <h2
                      className="text-[20px]  
                                  text-[#948A78] leading-snug mb-0 "
                    >
                      The Space at <br /> a Glance.
                    </h2>
                  </div>

                  <div
                    className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                                text-[13px]
                                leading-relaxed  tracking-wide text-[#948A78]"
                  >
                    <p className="mb-0 mt-0">
                      A 5-bedroom home with ensuite baths, vaulted living,
                      sun-washed courtyards, a private pool, and an open-sky
                      jacuzzi — designed for connection and calm.
                    </p>
                  </div>
                  <div>
                    <Link to="/OurSpaces">
                      <span
                        className="relative inline-block  tracking-widest uppercase cursor-pointer 
                                text-[#948A78] text-[13px]
                                hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                      >
                        OUR SPACES
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                <div className="flex justify-end items-center mb-6 lg:mb-2">
                  <span
                    className="tracking-widest uppercase text-[#948A78] 
                      text-[13px]"
                  >
                    THE DINING ROOM
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                  >
                    <path
                      d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                      stroke="#948A78"
                      strokeWidth="1.5"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                  <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4a822b9a-c410-4eaa-e40e-48f0cc623000/public" //Tao_home_10.webp
                          alt="living Detail 1"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1c12a187-829f-40d2-e80e-ad6a45dbc200/public" //Tao_home_11.webp
                          alt="living Detail 2"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* -------- PANEL 3 -------- */}
        <section
          ref={registerPanel}
          className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -ml-1"
        >
          <div
            className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10 
                            px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
          >
            <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
              <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3ab68105-6e37-41e5-3f1c-0fd16e867400/public" //Tao_home_12.webp
                  alt="Living Room"
                  className="
                       lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
                       lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
                      object-cover shadow-lg transition-all duration-300"
                />
                <div
                  className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
                              4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
                              transform -translate-y-1/2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
                  >
                    <path
                      d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
                      stroke="#948A78"
                      stroke-width="1.0"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Bottom Left Text */}
              <div
                className="lg:w-[98%] xl:w-[70%] 2xl:w-[520px] 4k:w-[550px]
                            text-[13px]
                            leading-relaxed  tracking-wide text-[#948A78]"
              >
                <p className="mb-4">
                  In a quiet corner, tea is brewed not for caffeine but for
                  consciousness. The ritual is simple, almost sacred.
                </p>
                <p className="mb-4">
                  Sip. Pause. Tap the table softly when the cup is empty, a
                  gesture of thanks. The house honors Taoism, not through
                  symbols, but through rhythm.
                </p>
                <p className="mb-4">
                  Be here & now. <br />
                  That’s the only rule. <br />
                  That’s the only truth.
                </p>
              </div>
            </div>

            <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
              <div
                className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto 
                            px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24 
                            mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
              >
                <div className="flex flex-col justify-center items-start  space-y-4">
                  <div className="text-right -ml-32">
                    <h2
                      className="text-[20px]  
                                  text-[#948A78] leading-snug mb-0 "
                    >
                      The Space at <br /> a Glance.
                    </h2>
                  </div>

                  <div
                    className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
                                text-[13px]
                                leading-relaxed  tracking-wide text-[#948A78]"
                  >
                    <p className="mb-0 mt-0">
                      A 5-bedroom home with ensuite baths, vaulted living,
                      sun-washed courtyards, a private pool, and an open-sky
                      jacuzzi — designed for connection and calm.
                    </p>
                  </div>
                  <div>
                    <Link to="/OurSpaces">
                      <span
                        className="relative inline-block  tracking-widest uppercase cursor-pointer 
                                text-[#948A78] text-[13px]
                                hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                      >
                        OUR SPACES
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
                <div className="flex justify-end items-center mb-6 lg:mb-2">
                  <span
                    className="tracking-widest uppercase text-[#948A78] 
                      text-[13px]"
                  >
                    Bedroom 01
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 160 25"
                    className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3 
                                transition-transform duration-300 hover:translate-x-1"
                  >
                    <path
                      d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                      stroke="#948A78"
                      strokeWidth="1.5"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
                  <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a999cea9-fbbc-4eed-df8e-2eda6370cd00/public" //Tao_home_13.webp
                          alt="living Detail 1"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>

                    <div className="w-full sm:w-1/2">
                      <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
                        <img
                          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/40614264-4460-4c41-5137-a36314e26c00/public" //Tao_home_14.webp
                          alt="living Detail 2"
                          className="w-full h-full object-cover shadow-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ---------- SECTION 8---------- */}
      <div className="hidden lg:flex relative w-full min-h-screen items-center justify-center bg-[#f5f2f0] z-10 pt-16 -mb-10 -mt-1 py-0 md:py-1 pb-20 md:pb-10">
        {/* <div className="w-full h-[70vh] md:h-screen relative">
          <img
            src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/17dfe8bb-fb2f-48f8-bad5-4cfad6602d00/public" //Tao_home_15new.webp
            alt="'IN SILENCE, EVERYTHING SPEAKS'"
            className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] object-cover"
          />

          <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-center">
            <p
              className="text-[#948A78] text-[13px] tracking-widest uppercase overflow-hidden whitespace-nowrap border-r-2 border-[#948A78]"
              style={{
                width: "0ch",
                animation:
                  "typing 2s steps(30) forwards, hideCursor 0.1s 2.2s forwards",
              }}
            >
              IN SILENCE, EVERYTHING SPEAKS
            </p>
          </div>
        </div> */}

        <div className="w-full h-[70vh] md:h-screen relative">
          {!isPlaying && (
            <>
              <img
                src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/17dfe8bb-fb2f-48f8-bad5-4cfad6602d00/public"
                alt="'IN SILENCE, EVERYTHING SPEAKS'"
                className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] object-cover cursor-pointer"
                onClick={() => setIsPlaying(true)}
              />

              <div
                className="absolute inset-0 bg-black/0 cursor-pointer"
                onClick={() => setIsPlaying(true)}
              />

              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={() => setIsPlaying(true)}
              >
                <div className="inline-block bg-white/0 p-5 rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
                  <div className="bg-white/70 p-4 rounded-full shadow-lg">
                    <FaPlay className="text-[#948A78] p-2 pl-3 text-4xl" />
                  </div>
                </div>
              </div>

              <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-center">
                <p
                  className="text-[#948A78] text-[13px] tracking-widest uppercase overflow-hidden whitespace-nowrap border-r-2 border-[#948A78]"
                  style={{
                    width: "0ch",
                    animation:
                      "typing 2s steps(30) forwards, hideCursor 0.1s 2.2s forwards",
                  }}
                >
                  IN SILENCE, EVERYTHING SPEAKS
                </p>
              </div>
            </>
          )}

          {isPlaying && (
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/H6u9yKWoixY?autoplay=1"
              title="YouTube video player"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          )}
        </div>

        <style jsx>{`
          @keyframes typing {
            from {
              width: 0;
            }
            to {
              width: 30ch;
            }
          }

          /* Cursor disappear after typing */
          @keyframes hideCursor {
            to {
              border-color: transparent;
            }
          }
        `}</style>
      </div>

      {/* ---------- SECTION 9 --------- */}
      <div
        ref={addToRefs}
        className="hidden lg:block relative w-full bg-[#f5f2f0] py-16 sm:py-20 lg:py-24 px-4 sm:px-8 md:px-12 lg:px-7 xl:px-28 2xl:px-40 4k:px-48 z-20 -mb-1"
      >
        <div className="flex flex-col lg:flex-row justify-between gap-12 xl:gap-24 4k:gap-36 4k:mt-28 4k:mb-44 xl:mb-28 lg:mb-24 ">
          <div className="w-full lg:w-1/2 flex flex-col order-1 lg:order-1">
            <h2 className="text-[20px]  tracking-wide text-[#948A78] mb-6 pb-0">
              OUR SERVICES
            </h2>

            <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-16">
              Curated experiences, thoughtfully delivered. At House of Tāo, our
              in-house concierge service is here to enhance your stay with
              curated experiences, local insights, and seamless planning — so
              you can focus on unwinding.
            </p>

            <div className="w-full mt-8 sm:mt-10 mb-0 order-3 lg:order-1">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/73fff923-e47a-472f-0d24-f3cda7303500/public" //Tao_home_16.webp
                alt="Concierge services by the pool"
                className="w-[80vh] h-[55vh] object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col justify-end items-end order-2 lg:order-2 4k:pl-40 4k:pr-16">
            <div className="w-full 4k:max-w-[70%]">
              <div className="4k:-ml-56 2xl:ml-4 xl:ml-6 lg:ml-0">
                <h2 className="text-[20px]  tracking-wide text-[#948A78] mb-2">
                  What We Offer
                </h2>
              </div>

              <div className="4k:-ml-20 2xl:mr-10 2xl:w-[600px] xl:ml-44 lg:ml-16">
                <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-8">
                  Our concierge can assist you with:
                </p>

                <div className="text-[#948A78] text-[13px] 4k:w-[690px] leading-relaxed  tracking-wide space-y-1 mb-10">
                  <p>
                    • Restaurant reservations at some of Goa’s best culinary
                    spots
                  </p>
                  <p>• Private transfers & guided itineraries</p>
                  <p>
                    • Spa appointments, wellness sessions & yoga instructors
                  </p>
                  <p>• Decor for intimate celebrations</p>
                  <p>• On-call chef experiences & wine/gin tastings</p>
                  <p>• Yacht charters, beach picnics & cultural explorations</p>
                </div>

                <p className="text-[#948A78] text-[13px] lg:w-[450px] xl:w-[500px] 2xl:w-[500px] 4k:w-[500px] leading-relaxed  tracking-wide mb-24">
                  All in-villa services (spa, setup, décor, etc.) must be booked
                  through our concierge to ensure quality, safety, and
                  consistency of service.
                </p>

                <p className="text-[#948A78] text-[13px] lg:w-[450px] xl:w-[500px] 2xl:w-[460px] 4k:w-[500px] leading-relaxed  tracking-wide mb-6">
                  We’re here to ensure your stay is not only peaceful, but
                  seamless — curated with care, hosted with intention. For any
                  assistance, please reach out to your Villa Manager or
                  Concierge Team directly during your stay.
                </p>
              </div>

              <div className="pt-2 4k:-ml-20 2xl:ml-44 2xl:w-[600px] xl:ml-44 lg:ml-16 mb-2">
                <Link to="/OurServices">
                  <span
                    className="relative inline-block  tracking-widest uppercase cursor-pointer text-[#948A78] text-[13px] 
                hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                  >
                    explore our services
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- SECTION 10 (LOCATION & SURROUNDINGS) ---------- */}
      <div className="hidden lg:block relative w-full bg-[#f5f2f0] py-6 sm:py-8 md:py-10 lg:py-16 xl:py-20 2xl:py-20 4k:py-20 px-4 lg:px-0 xl:px-0 2xl:px-0 4k:px-0 z-10 mt-0">
        <div className="flex flex-col lg:flex-row justify-between items-stretch gap-10 xl:gap-16 2xl:gap-20 4k:gap-32">
          <div
            ref={addToRefs}
            className="w-full lg:w-1/3 flex flex-col justify-end lg:pl-20 xl:pl-28 2xl:pl-36 4k:pl-48 2xl:mr-0 lg:mr-20 4k:mr-20 pb-8 lg:pb-12"
          >
            <h2 className="text-[20px] uppercase tracking-wide text-[#948A78] mb-8 lg:mb-12 mt-6 lg:mt-8">
              Location & Surroundings
            </h2>

            <p className="text-[#948A78] text-[13px] leading-relaxed tracking-wide mb-6">
              A village where time moves a little slower. Parra has its own
              pace: calm, familiar and quietly alive.
            </p>

            <p className="text-[#948A78] text-[13px] leading-relaxed tracking-wide mb-6">
              It’s not where the parties are, but they’re not far either.
              Beaches like Anjuna and Vagator, and the cafés of Assagao, are
              just a short drive away.
            </p>

            <p className="text-[#948A78] text-[13px] leading-relaxed tracking-wide">
              That’s what makes this place special: it gives you room to
              retreat, without losing touch with everything else.
            </p>
          </div>

          <div className="w-full lg:w-2/3 mt-8 lg:mt-0 flex justify-end overflow-auto border border-gray-200">
            <a
              href="https://www.google.com/maps/place/House+of+T%C4%81o/@15.5688409,73.7760582,17z/data=!4m6!3m5!1s0x3bbfeb0008e29bbd:0x1875561695f3fb56!8m2!3d15.5688357!4d73.7786331!16s%2Fg%2F11xdhwzpr0?authuser=0&entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3b389f03-5e51-45af-ac44-8240d8265500/public"
                alt="House of Tao Map"
                className="w-[1200px] h-[600px] object-cover cursor-pointer"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="hidden lg:block">
        <NewFooter />
      </div>

      {/* ------------------ MOBILE ------------------ */}
      <div className="lg:hidden">
        <div className="flex flex-col lg:hidden text-center relative overflow-x-hidden bg-[#f5f2f0]">
          {/* SECTION 1 */}
          <div
            className="fixed inset-0 w-full h-full bg-cover bg-center z-0"
            style={{
              backgroundImage: `url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d5f647fd-2d2f-438b-7aef-2d1ff65bf700/public')`, //Tao_Homebanner.webp
            }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-[#F5F2F0] z-10">
              <img
                src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/83b28aec-0ca2-4344-32a0-bee3d7db0400/public" // tao_logo_full.png
                alt="House of Tao"
                className="w-[100px] lg:w-[130px] mt-2 animate-zoom-in"
              />

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="absolute bottom-7 text-[13px] tracking-[0.20em] uppercase text-[#F5F2F0] text-center"
              >
                WELCOME HOME,
                <br /> TO YOURSELF
              </motion.p>
            </div>
          </div>

          <div className="relative z-10 pt-[100vh]">
            <style jsx global>{`
              /* TEXT ANIMATION */
              @keyframes slideUp {
                from {
                  opacity: 0;
                  transform: translateY(20px);
                }
                to {
                  opacity: 1;
                  transform: translateY(0);
                }
              }

              .animate-slide-up {
                animation: slideUp 1s ease-out 1s forwards;
              }

              /* NEW SMALL → BIG ANIMATION */
              @keyframes zoomInGrow {
                0% {
                  opacity: 0;
                  transform: scale(0.7);
                }
                100% {
                  opacity: 1;
                  transform: scale(1);
                }
              }

              .animate-zoom-in {
                animation: zoomInGrow 1.2s ease-out forwards;
              }
            `}</style>

            <NewHeader />

            {/* SECTION 2 */}
            <section
              id="section2"
              // ref={addToRefs}
              className="relative z-20 flex flex-col items-center w-full bg-[#f5f2f0] mt-0 mb-0"
            >
              <div className="flex justify-start w-full px-5">
                <div className="relative w-[45vh] h-[45vh] sm:w-[85vh] sm:h-[60vh] -ml-5 overflow-hidden">
                  <motion.img
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 3, ease: "easeOut" }}
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
                    alt="Living Room"
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
              <div className="flex w-full justify-end px-5 py-8 md:items-start md:h-screen">
                <div className="text-[#948A78] leading-[1.9] tracking-wide text-right space-y-2 mb-1 text-[13px] sm:mb-40">
                  <motion.p
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 6, ease: "easeOut" }}
                  >
                    A space to pause, <br /> to feel the wind move <br />{" "}
                    through arches, <br /> to watch the light <br /> fall
                    without urgency.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 90 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 6, ease: "easeOut" }}
                  >
                    Rooted in Taoist principles <br /> of balance and presence,{" "}
                    <br /> our home is crafted to <br /> help you return to
                    yours — <br /> the one within.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 130 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 6, ease: "easeOut" }}
                  >
                    Come as you are. <br /> Leave a little lighter.
                  </motion.p>
                </div>
              </div>
            </section>

            {/* SECTION 3 */}
            <div
              // ref={addToRefs}
              className="relative z-20 flex w-full flex-col items-center justify-between bg-[#f5f2f0] pt-0 px-6 sm:px-20"
            >
              <div className="w-full flex justify-center mb-8 sm:-mt-40 mt-4 sm:ml-80 ml-10">
                <motion.img
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 4, ease: "easeOut" }}
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/07f16891-b0d9-4bc3-4a33-74c470751000/public" //Tao_home_3.webp
                  alt="Philosophy"
                  className="shadow-lg w-[55vh] h-[85vh] sm:w-[50vh] sm:h-[75vh] object-cover"
                />
              </div>
              <div className="w-full sm:w-4/5 text-[#948A78] text-[12px] sm:text-[13px]  leading-[1.9] tracking-wide space-y-3 text-left relative">
                <div className="flex justify-center mb-4 sm:mr-80 mr-52">
                  <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 3, ease: "easeOut" }}
                    className="text-[20px]  text-[#948A78] text-right leading-snug"
                  >
                    Our <br /> Philosophy
                  </motion.h2>
                </div>
                <div className="space-y-3 text-left text-[13px] sm:ml-40 ml-14 w-[250px] sm:w-[350px]">
                  <motion.p
                    initial={{ opacity: 0, y: 90 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                  >
                    House of Tao is designed to help you disconnect from noise
                    and reconnect with what matters: nature, rest, and self.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 130 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                  >
                    We follow Taoist principles: living in alignment with the
                    natural world, choosing presence over pace and embracing the
                    simple beauty of each moment.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 170 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                  >
                    From the outside, it’s quiet and grounded. But step in and
                    you’ll feel something shift — not because of grand gestures
                    or luxury for luxury’s sake, but because every corner has
                    been thought through.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 210 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                  >
                    Here, beauty is not about perfection. It’s about presence —
                    in the way light moves through a room, in how time begins to
                    stretch, in how you begin to return to yourself.
                  </motion.p>
                  <motion.p
                    initial={{ opacity: 0, y: 250 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                  >
                    Welcome home. To yourself.
                  </motion.p>
                </div>
                <motion.div
                  initial={{ opacity: 0, y: 250 }}
                  animate={{ opacity: 1, y: -2 }}
                  transition={{ duration: 8, ease: "easeOut" }}
                  className="text-[13px] flex justify-center items-center w-full mt-8 sm:-ml-8 -ml-9"
                >
                  <a href="/OurPhilosophy">
                    <p className=" tracking-widest uppercase text-[#948A78] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
                      learn more
                    </p>
                  </a>
                </motion.div>
              </div>
            </div>

            {/* SECTION 4 */}
            <section
              id="section4"
              className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0]"
            >
              <div className="w-full flex justify-center mt-10">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e8195ab7-4494-4280-534c-cf52841a6d00/public" //Tao_home_5.webp
                  alt="Modern Architecture"
                  className="w-full h-auto object-cover transition-all duration-500"
                />
              </div>
            </section>

            {/* SECTION 5 */}
            <section
              id="section5"
              ref={addToRefs}
              className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] text-[#948A78] py-20"
            >
              <div className="flex flex-col items-start justify-center text-left max-w-sm sm:max-w-md px-8">
                <div>
                  <motion.h2
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 8, ease: "easeOut" }}
                    className="text-[20px] text-right mb-4 leading-snug sm:-ml-14"
                  >
                    The Space at <br /> a Glance
                  </motion.h2>
                </div>
                <motion.p
                  initial={{ opacity: 0, y: 80 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 9, ease: "easeOut" }}
                  className="text-[13px] leading-relaxed mb-8 ml-28 sm:ml-20"
                >
                  A 5-bedroom home with ensuite baths, vaulted living,
                  sun-washed courtyards, a private pool, and an open-sky jacuzzi
                  — designed for connection and calm.
                </motion.p>

                <div className="flex items-center space-x-2 cursor-pointer group">
                  <Link to="/OurSpaces">
                    <p className="text-[13px] tracking-[0.2em] uppercase  pb-[2px] text-[#948A78] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300 sm:ml-20 ml-28">
                      our spaces
                    </p>
                  </Link>
                </div>
              </div>
            </section>

            {/* ------------------ MOBILE CAROUSEL ------------------ */}
            <div
              className="flex w-full h-screen overflow-hidden"
              ref={mobileCarouselRef}
            >
              {/* ---------------- PANEL 1 ---------------- */}
              <div
                ref={registerPanel}
                className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
              >
                <div className="w-full flex flex-col items-center">
                  <div className="w-full flex justify-start">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
                      alt="Living Room Main"
                      className="sm:w-[85vh] w-[43vh] sm:h-[60vh] h-[30vh] object-cover"
                    />
                  </div>

                  <div className="flex justify-end items-center mt-3 mb-8">
                    <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-80 ml-16">
                      THE LIVING ROOM
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-72 ml-10 mb-3 max-w-xs">
                    This space is designed for pause.
                    <br />
                    For conversation.
                    <br />
                    For silence.
                    <br />
                    For everything in between.
                  </p>

                  <div className="grid grid-cols-2 justify-end gap-3 ml-[20%] mr-4">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80626821-ded1-416c-b3ce-80561ba7f300/public" //Tao_home_7.webp
                      alt="Cozy Reading Spot"
                      className="w-full h-[30vh] object-cover"
                    />
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
                      alt="Living Room Interior"
                      className="w-full h-[30vh] object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* ---------------- PANEL 2 ---------------- */}
              <div
                ref={registerPanel}
                className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
              >
                <div className="w-full flex flex-col items-center">
                  <div className="w-full flex justify-start">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/aa26ac68-9831-4885-8242-0f193f766000/public" //Tao_home_4.webp
                      alt="Living & Dining"
                      className="sm:w-[85vh] w-[43vh] sm:h-[60vh] h-[30vh] object-cover"
                    />
                  </div>

                  <div className="flex justify-end items-center mt-3 mb-8">
                    <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-[70vh] ml-16">
                      living & dining
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-96 ml-24 mb-3 w-[190px] sm:w-[200px]">
                    Open-plan spaces with curated decor, blending modern design
                    with Goan charm.
                  </p>

                  <div className="grid grid-cols-2 justify-end gap-3 ml-[20%] mr-4">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4a822b9a-c410-4eaa-e40e-48f0cc623000/public"
                      alt="Cozy Reading Spot"
                      className="w-full h-[30vh] object-cover"
                    />
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1c12a187-829f-40d2-e80e-ad6a45dbc200/public"
                      alt="Living Room Interior"
                      className="w-full h-[30vh] object-cover"
                    />
                  </div>
                </div>
              </div>

              {/* ---------------- PANEL 3 ---------------- */}
              <div
                ref={registerPanel}
                className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
              >
                <div className="w-full flex flex-col items-center">
                  <div className="w-full flex justify-start">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3b1cca27-d5ae-4ef1-855c-1c97573c7300/public" //Tao_home_17.webp
                      alt="The Pool & Jacuzzi"
                      className="sm:w-[85vh] w-[43vh] sm:h-[60vh] h-[30vh] object-cover"
                    />
                  </div>

                  <div className="flex justify-end items-center mt-3 mb-8">
                    <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-[70vh] ml-16">
                      the pool & jacuzzi
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 160 25"
                      className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
                    >
                      <path
                        d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
                        stroke="#948A78"
                        strokeWidth="1.5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-96 ml-24 mb-3 w-[190px] sm:w-[200px]">
                    A private retreat framed by greenery, perfect for a morning
                    swim or an evening unwind.
                  </p>

                  <div className="grid grid-cols-2 justify-end gap-3 ml-[20%] mr-4 w-[75%]">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a999cea9-fbbc-4eed-df8e-2eda6370cd00/public"
                      alt="Cozy Reading Spot"
                      className="w-full h-[30vh] object-cover"
                    />
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/40614264-4460-4c41-5137-a36314e26c00/public"
                      alt="Living Room Interior"
                      className="w-full h-[30vh] object-cover"
                    />
                  </div>

                  {/* <div className="grid grid-cols-2 justify-end gap-3 ml-[20%] mr-4">
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a999cea9-fbbc-4eed-df8e-2eda6370cd00/public"
                      alt="Cozy Reading Spot"
                      className="w-full h-[30vh] object-cover"
                    />
                    <img
                      src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/40614264-4460-4c41-5137-a36314e26c00/public"
                      alt="Living Room Interior"
                      className="w-full h-[30vh] object-cover"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            {/* ---------------- SECTION 9 ---------------- */}
            {/* <section
              id="section9"
              // ref={addToRefs}
              className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] py-10 lg:hidden"
            >
              <div className="sm:ml-[35vh] flex grid-cols-2 gap-1 w-full justify-center">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80626821-ded1-416c-b3ce-80561ba7f300/public" //Tao_home_7.webp
                  alt="Cozy Reading Spot"
                  className="sm:w-[45vh] sm:h-[65vh] w-[30vh] h-[50vh] object-cover"
                />
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
                  alt="Living Room Interior"
                  className="sm:w-[45vh] sm:h-[65vh] w-[30vh] h-[50vh] object-cover"
                />
              </div>
            </section> */}

            {/* ---------------- SECTION 10 ---------------- */}
            <div className="flex lg:hidden relative w-full min-h-screen items-center justify-center bg-[#f5f2f0] z-10 pt-16 -mb-10 -mt-1 py-0 md:py-1 pb-20 md:pb-10">
              {/* <div className="w-full h-[70vh] md:h-screen relative">
                <img
                  src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/17dfe8bb-fb2f-48f8-bad5-4cfad6602d00/public" //Tao_home_15new.webp
                  alt="'IN SILENCE, EVERYTHING SPEAKS'"
                  className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] 4k:h-[100vh] object-cover"
                />
                <div className="absolute left-0 right-0 bottom-0 text-center pb-0 md:pb-10">
                  <motion.p
                    initial={{ opacity: 0, y: 80 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 9, ease: "easeOut" }}
                    className="text-[#948A78] text-[13px] tracking-widest uppercase -mb-16 "
                  >
                    IN SILENCE, EVERYTHING SPEAKS
                  </motion.p>
                </div>
              </div> */}

              <div className="w-full h-[70vh] md:h-screen relative">
                {!isPlaying && (
                  <>
                    <img
                      src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/17dfe8bb-fb2f-48f8-bad5-4cfad6602d00/public"
                      alt="'IN SILENCE, EVERYTHING SPEAKS'"
                      className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] 4k:h-[100vh] object-cover cursor-pointer"
                      onClick={() => setIsPlaying(true)}
                    />

                    <div
                      className="absolute inset-0 bg-black/0 cursor-pointer"
                      onClick={() => setIsPlaying(true)}
                    />

                    <div
                      className="absolute inset-0 flex items-center justify-center cursor-pointer"
                      onClick={() => setIsPlaying(true)}
                    >
                      <div className="inline-block bg-white/0 p-5 rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
                        <div className="bg-white/70 p-4 rounded-full shadow-lg">
                          <FaPlay className="text-[#948A78] p-2 pl-3 text-4xl" />
                        </div>
                      </div>
                    </div>

                    <div className="absolute left-0 right-0 bottom-0 text-center pb-0 md:pb-10">
                      <motion.p
                        initial={{ opacity: 0, y: 80 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 9, ease: "easeOut" }}
                        className="text-[#948A78] text-[13px] tracking-widest uppercase -mb-16"
                      >
                        IN SILENCE, EVERYTHING SPEAKS
                      </motion.p>
                    </div>
                  </>
                )}

                {isPlaying && (
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/H6u9yKWoixY?si=gGVC4hm80F3a1jCv"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                )}
              </div>
            </div>

            {/* ---------------- SECTION 11 ---------------- */}
            <section
              id="section11"
              ref={addToRefs}
              className="py-10 bg-[#f5f2f0] relative z-20 lg:hidden"
            >
              <div className="max-w-6xl mx-auto px-4 sm:px-6 sm:mt-20">
                <div className="text-left md:text-left md:max-w-2xl md:ml-80 ml-32">
                  <h2 className="text-[13px] tracking-[0.3em] uppercase text-[#948A78] mb-6">
                    OUR SERVICES
                  </h2>
                  <p className="text-[13px] text-[#948A78] leading-relaxed">
                    Curated experiences, thoughtfully delivered At House of Tāo,
                    our in-house concierge service is here to enhance your stay
                    with curated experiences, local insights, and seamless
                    planning — so you can focus on unwinding.
                  </p>
                </div>

                <div className="mt-10 flex justify-start">
                  <div className="w-full max-w-4xl">
                    <div className="relative w-[60vh] h-[60vh] sm:w-[85vh] sm:h-[60vh] -ml-6 overflow-hidden">
                      <img
                        src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/73fff923-e47a-472f-0d24-f3cda7303500/public" //Tao_home_16.webp
                        alt="Person relaxing in a pool under a decorative awning at House of Tāo"
                        className="sm:w-[80vh] sm:h-[50vh] h-[58vh] w-[50vh] object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ---------------- SECTION 12 ---------------- */}
            <section
              id="section12"
              ref={addToRefs}
              className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] text-[#948A78] py-8 lg:hidden"
            >
              <div className="flex flex-col items-start justify-center text-left max-w-sm sm:max-w-md px-6 sm:px-8 space-y-4 sm:mr-80 mr-44">
                <h2 className="text-[20px] mb-2 leading-snug">What We Offer</h2>
              </div>

              <div className="flex flex-col items-start text-[13px] justify-center text-left w-[320px] sm:w-[400px] px-6 sm:px-8 space-y-4 sm:ml-40 ml-16">
                <p className="leading-relaxed">
                  Our concierge can assist you with:
                </p>

                <p className="leading-relaxed space-y-1">
                  • Restaurant reservations at some of Goa’s best culinary spots{" "}
                  <br />
                  • Private transfers & guided itineraries <br />• Spa
                  appointments, wellness sessions & yoga instructors <br />
                  • Decor for intimate celebrations <br />
                  • On-call chef experiences & wine/gin tastings <br />• Yacht
                  charters, beach picnics & cultural explorations
                </p>

                <p>
                  All in-villa services (spa, setup, décor, etc.) must be booked
                  through our concierge to ensure quality, safety, and
                  consistency of service.
                </p>

                <p>
                  We’re here to ensure your stay is not only peaceful, but
                  seamless — curated with care, hosted with intention. For any
                  assistance, please reach out to your Villa Manager or
                  Concierge Team directly during your stay.
                </p>

                <div className="flex items-center cursor-pointer group mt-4">
                  <Link to="/OurServices">
                    <p className="text-[13px] tracking-[0.2em] uppercase pb-[2px] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
                      explore our services
                    </p>
                  </Link>
                </div>
              </div>
            </section>

            {/* ---------------- SECTION 13 ---------------- */}
            <section
              id="section13"
              ref={addToRefs}
              className="relative z-20 flex lg:hidden flex-col items-center w-full bg-[#f5f2f0] mt-0 pb-10"
            >
              <div className="relative w-[65vh] h-[65vh] sm:w-[45vh] sm:h-[60vh] sm:mr-96 ml-10 overflow-hidden">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
                  alt="Living Room"
                  className="object-cover w-[45vh] h-[60vh] sm:w-[45vh] sm:h-[60vh]"
                />
              </div>

              <div className="w-full px-5 mt-4">
                <div className="text-[#948A78] leading-[1.9]  tracking-wide text-left space-y-2 text-[13px] sm:w-[350px] sm:ml-80 w-[200px] ml-24">
                  <p>
                    Whether you’re planning your next getaway, looking for a
                    special celebration venue, or simply curious to know more —
                    we’d love to hear from you.
                  </p>
                  <Link to="/BookNow">
                    <p className="text-[13px] tracking-[0.2em] uppercase pb-5 mt-5 hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
                      BOOK YOUR STAY
                    </p>
                  </Link>
                </div>
              </div>
            </section>
            <div className="lg:hidden hidden:block">
              <NewFooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;

// import React, { useEffect, useRef } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Link } from "react-router-dom";

// import NewHeader from "../Header/NewHeader";
// import NewFooter from "../Footer/NewFooter";

// gsap.registerPlugin(ScrollTrigger);

// const HomePage = () => {
//   const sectionsRef = useRef([]);

//   const desktopCarouselRef = useRef(null);
//   const mobileCarouselRef = useRef(null);
//   const sectionsRef1 = useRef([]);

//   const registerPanel = (el) => {
//     if (el && !sectionsRef1.current.includes(el)) {
//       sectionsRef1.current.push(el);
//     }
//   };

//   // const initHorizontalScroll = (ref) => {
//   //   if (!ref.current) return;

//   //   const sections = gsap.utils.toArray(".panel", ref.current);

//   //   gsap.to(sections, {
//   //     xPercent: -100 * (sections.length - 1),
//   //     ease: "none",
//   //     scrollTrigger: {
//   //   trigger: refToUse.current,
//   //   pin: true,
//   //   scrub: 1.2,
//   //   snap: 1 / (sections.length - 1),
//   //   end: () => "+=" + refToUse.current.offsetWidth * (sections.length - 1) * 6,
//   // },

//   //   });
//   // };

//   useEffect(() => {
//     const initCarousel = () => {
//       ScrollTrigger.getAll().forEach((t) => t.kill());

//       const refToUse =
//         window.innerWidth >= 1024 ? desktopCarouselRef : mobileCarouselRef;
//       if (!refToUse.current) return;

//       const sections = gsap.utils.toArray(".panel", refToUse.current);

//       const horizontalTween = gsap.to(sections, {
//         xPercent: -100 * (sections.length - 1),
//         ease: "none",
//         scrollTrigger: {
//           trigger: refToUse.current,
//           pin: true,
//           scrub: 0.5,
//           snap: 1 / (sections.length - 1),

//           end: () =>
//             "+=" + refToUse.current.offsetWidth * (sections.length - 1),
//         },
//       });

//       sectionsRef1.current.forEach((section) => {
//         const elements = section.querySelectorAll("h2, p");

//         gsap.fromTo(
//           elements,
//           {
//             x: 150,
//             opacity: 0,
//           },
//           {
//             x: 0,
//             opacity: 1,
//             duration: 1,
//             stagger: 0.3,
//             ease: "power3.out",
//             scrollTrigger: {
//               containerAnimation: horizontalTween,
//               trigger: section,
//               start: "left center",
//               end: "right center",
//               scrub: false,
//             },
//           }
//         );
//       });

//       ScrollTrigger.refresh();
//     };

//     initCarousel();
//     window.addEventListener("resize", initCarousel);
//     return () => window.removeEventListener("resize", initCarousel);
//   }, []);

//   // all
//   const addToRefs = (el) => {
//     if (el && !sectionsRef.current.includes(el)) {
//       sectionsRef.current.push(el);
//     }
//   };

//   useEffect(() => {
//     sectionsRef.current.forEach((section) => {
//       const texts = section.querySelectorAll("p, h2");

//       gsap.fromTo(
//         texts,
//         { opacity: 0, y: 50 },
//         {
//           opacity: 1,
//           y: 0,
//           duration: 1,
//           stagger: 0.3,
//           ease: "power2.out",
//           scrollTrigger: {
//             trigger: section,
//             start: "top 80%",
//             toggleActions: "play none none none",
//           },
//         }
//       );

//       const images = section.querySelectorAll("img");

//       images.forEach((img) => {
//         gsap.fromTo(
//           img,
//           { opacity: 0, y: 50 },
//           {
//             opacity: 1,
//             y: 0,
//             duration: 0.1,
//             ease: "power2.out",
//             scrollTrigger: {
//               trigger: img,
//               start: "top 85%",
//               toggleActions: "play none none none",
//             },
//           }
//         );
//       });
//     });
//   }, []);

//   return (
//     <div className="relative w-full overflow-hidden">
//       {/* ------------------ DESKTOP SECTION 1 ------------------ */}
//       <div
//         className="hidden lg:flex fixed top-0 left-0 w-full h-screen flex-col items-center justify-center bg-cover bg-center"
//         style={{
//           backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a7115959-dd6c-4d20-5748-93b0511af900/public')`, // Tao_home_banner.webp
//         }}
//       >
//         <div className="absolute inset-0 bg-black/50 z-0"></div>
//         <div className="relative z-10 flex flex-col items-center justify-center text-center text-[#F5F2F0]">
//           <img
//             src="./assets/tao_logo_full.png"
//             alt="House of Tao"
//             className="w-[200px] lg:w-[130px] mt-2 animate-zoom-in"
//           />
//         </div>
//         <p className="absolute bottom-7 text-[13px] tracking-[0.20em] uppercase text-[#f5f5f0] z-10 text-center opacity-0 animate-slide-up">
//           WELCOME HOME, TO YOURSELF
//         </p>
//       </div>
//       <style jsx global>{`
//         @keyframes zoomInGrow {
//           0% {
//             opacity: 0;
//             transform: scale(0.7);
//           }
//           100% {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .animate-zoom-in {
//           animation: zoomInGrow 1.2s ease-out forwards;
//         }
//       `}</style>

//       {/* ------------------ DESKTOP SECTION 2 ------------------ */}
//       <div
//         id="section2"
//         className="hidden lg:grid relative mt-[110vh] z-10 w-full bg-[#f5f2f0] pb-5 2xl:-mb-1 grid-cols-[2fr_1fr]"
//       >
//         <div className="relative w-[85%] lg:w-[110%] h-[100vh] overflow-hidden">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
//             alt="Living Room"
//             className="object-cover w-full h-full"
//           />
//         </div>
//         <div
//           ref={addToRefs}
//           className="flex items-end justify-end px-8 sm:px-12 lg:px-16 py-10 2xl:py-20"
//         >
//           <div className="text-[#948A78] leading-[1.9]  tracking-wide text-right space-y-2 mb-1 text-[13px] 2xl:translate-y-6">
//             <p>
//               A space to pause, <br /> to feel the wind move <br /> through
//               arches, <br /> to watch the light <br /> fall without urgency.
//             </p>
//             <p>
//               Rooted in Taoist principles <br /> of balance and presence, <br />{" "}
//               our home is crafted to <br /> help you return to yours — <br />{" "}
//               the one within.
//             </p>
//             <p>
//               Come as you are. <br /> Leave a little lighter.
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="hidden lg:block">
//         <NewHeader />
//       </div>

//       {/* section 3 */}
//       <div
//         ref={addToRefs}
//         className="hidden lg:flex relative z-10 w-full items-center justify-between -mt-1 py-16 px-6 md:px-10 bg-[#f5f2f0]"
//       >
//         <div className="w-full md:w-1/2 flex justify-start mb-8 md:mb-6 -mt-10">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/07f16891-b0d9-4bc3-4a33-74c470751000/public" //Tao_home_3.webp
//             alt="Philosophy"
//             className=" lg:w-[90%] xl:w-[85%] 2xl:w-[90%] 4k:w-[100%] h-auto object-cover"
//           />
//         </div>

//         <div className="md:w-1/2 text-[#948A78] leading-[1.9] tracking-wide space-y-3 md:pl-12 text-left relative">
//           <div className="flex justify-end pr-[85%] 4k:pl-96">
//             <h2 className="text-[20px]  text-[#948A78] text-right leading-snug mb-0">
//               Our <br /> Philosophy
//             </h2>
//           </div>
//           <div className="flex flex-col items-end pr-[2%] space-y-2 text-[13px] lg:ml-[70px] xl:ml-[65px] 2xl:ml-[120px] 4k:ml-[380px] w-[350px]">
//             <p>
//               House of Tao is designed to help you disconnect from noise and
//               reconnect with what matters: nature, rest, and self.
//             </p>
//             <p>
//               We follow Taoist principles: living in alignment with the natural
//               world, choosing presence over pace and embracing the simple beauty
//               of each moment.
//             </p>
//             <p>
//               From the outside, it’s quiet and grounded. But step in and you’ll
//               feel something shift — not because of grand gestures or luxury for
//               luxury’s sake, but because every corner has been thought through.
//             </p>
//             <p>
//               Here, beauty is not about perfection. It’s about presence — in the
//               way light moves through a room, in how time begins to stretch, in
//               how you begin to return to yourself.
//             </p>
//             <div className="lg:h-5 xl:h-12 2xl:h-16 4k:h-16"></div>
//             <div className="flex justify-between items-center w-full max-w-[350px]">
//               <p className="text-right text-[13px] lg:mb-10">
//                 Welcome home. To yourself.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="hidden lg:flex w-full md:w-1/2 justify-end -mt-96 mb-6 -mr-2 ml-4">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
//             alt="Philosophy1"
//             className="shadow-lg lg:w-[95%] xl:w-[80%] 2xl:w-[75%] 4k:w-[85%] h-auto object-cover"
//           />
//         </div>

//         <div className="absolute bottom-28 right-[3%] xl:right-[2%] 2xl:right-[12%] 4k:right-[2%] text-[13px] z-50">
//           <div className="flex items-center space-x-12 text-[#948A78]">
//             <a href="/OurPhilosophy">
//               <p className="text-[13px] tracking-widest uppercase cursor-pointer hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
//                 Learn more
//               </p>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* ------------------ DESKTOP SECTION 4 ------------------ */}
//       <div className="hidden lg:flex relative w-full flex-col-reverse md:flex-row items-end justify-between -mt-10 -mb-1 bg-[#f5f2f0] py-0 md:py-1 px-6 md:px-10 pb-20">
//         <div className="w-full md:w-2/3 flex justify-center md:justify-start md:order-1 order-2">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e8195ab7-4494-4280-534c-cf52841a6d00/public" //Tao_home_5.webp
//             alt="Modern Architecture"
//             className="w-full lg:max-w-[700px] xl:max-w-[910px] 2xl:max-w-[900vh] 3xl:max-w-[1000vh] 4k:max-w-[1300vh] h-auto object-cover rounded-none transition-all duration-500"
//           />
//         </div>

//         <div
//           ref={addToRefs}
//           className="w-full md:w-1/3 flex justify-center md:justify-end mt-6 md:mt-0 md:order-2 order-1"
//         >
//           <div className="text-[#948A78] text-[13px] leading-relaxed text-left  tracking-wide md:ml-10 md:mb-10">
//             <p>
//               We started with a sense of balance, ease, and how we wanted people
//               to show up. The purpose of House of Tao is to help you detach from
//               the outside world and re-establish a connection with nature,
//               relaxation, and yourself.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* ------------------ DESKTOP CAROUSEL ------------------ */}
//       <div
//         className="hidden lg:flex w-full h-screen overflow-hidden bg-[#f5f2f0]"
//         ref={desktopCarouselRef}
//       >
//         {/* -------- PANEL 1 -------- */}
//         <section
//           ref={registerPanel}
//           className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -mr-1"
//         >
//           <div
//             className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10
//                             px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
//           >
//             <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
//               <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
//                   alt="Living Room"
//                   className="
//                        lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
//                        lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
//                       object-cover shadow-lg transition-all duration-300"
//                 />
//                 <div
//                   className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
//                               4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
//                               transform -translate-y-1/2"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
//                   >
//                     <path
//                       d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
//                       stroke="#948A78"
//                       stroke-width="1.0"
//                       fill="none"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </div>
//               </div>

//               <div
//                 className="lg:w-[98%] xl:w-[90%] 2xl:w-[520px] 4k:w-[550px]
//                             text-[13px]
//                             leading-relaxed  tracking-wide text-[#948A78]"
//               >
//                 <p className="mb-4">
//                   This space is designed for pause. <br />
//                   For conversation. <br />
//                   For silence. <br />
//                   For everything in between.
//                 </p>
//                 <p className="mb-4">
//                   One seating is a deep, sectional sofa, perfect for long hours
//                   and even longer conversations. Another faces the TV, for easy,
//                   familiar comfort. In one corner, a round window offers a cozy
//                   reading spot.
//                 </p>
//                 <p className="mb-4">
//                   There’s also a small bar tucked into the space, ideal for an
//                   evening drink.
//                 </p>
//               </div>
//             </div>

//             <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
//               <div
//                 className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto
//                             px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24
//                             mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
//               >
//                 <div className="flex flex-col justify-center items-start  space-y-4">
//                   <div className="text-right -ml-32">
//                     <h2
//                       className="text-[20px]
//                                   text-[#948A78] leading-snug mb-0 "
//                     >
//                       The Space at <br /> a Glance.
//                     </h2>
//                   </div>

//                   <div
//                     className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
//                                 text-[13px]
//                                 leading-relaxed  tracking-wide text-[#948A78]"
//                   >
//                     <p className="mb-0 mt-0">
//                       A 5-bedroom home with ensuite baths, vaulted living,
//                       sun-washed courtyards, a private pool, and an open-sky
//                       jacuzzi — designed for connection and calm.
//                     </p>
//                   </div>
//                   <div>
//                     <Link to="/OurSpaces">
//                       <span
//                         className="relative inline-block  tracking-widest uppercase cursor-pointer
//                                 text-[#948A78] text-[13px]
//                                 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                       >
//                         OUR SPACES
//                       </span>
//                     </Link>
//                   </div>
//                 </div>
//               </div>

//               <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
//                 <div className="flex justify-end items-center mb-6 lg:mb-2">
//                   <span
//                     className="tracking-widest uppercase text-[#948A78]
//                       text-[13px]"
//                   >
//                     THE LIVING ROOM
//                   </span>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3
//                                 transition-transform duration-300 hover:translate-x-1"
//                   >
//                     <path
//                       d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                       stroke="#948A78"
//                       strokeWidth="1.5"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>

//                 <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
//                   <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80626821-ded1-416c-b3ce-80561ba7f300/public" //Tao_home_7.webp
//                           alt="living Detail 1"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>

//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
//                           alt="living Detail 2"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* -------- PANEL 2 -------- */}
//         <section
//           ref={registerPanel}
//           className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -mr-1"
//         >
//           <div
//             className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10
//                             px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
//           >
//             <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
//               <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5ae81ca8-28ab-4902-84c6-bd0f6dd4c900/public" //Tao_home_9.webp
//                   alt="Living Room"
//                   className="
//                        lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
//                        lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
//                       object-cover shadow-lg transition-all duration-300"
//                 />
//                 <div
//                   className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
//                               4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
//                               transform -translate-y-1/2"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
//                   >
//                     <path
//                       d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
//                       stroke="#948A78"
//                       stroke-width="1.0"
//                       fill="none"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </div>
//               </div>

//               <div
//                 className="lg:w-[98%] xl:w-[70%] 2xl:w-[520px] 4k:w-[550px]
//                             text-[13px]
//                             leading-relaxed  tracking-wide text-[#948A78]"
//               >
//                 <p className="mb-4">
//                   The dining space brings people together, it seats 14 with ease
//                   and opens straight onto the verandah, so the breeze flows in
//                   without asking.
//                 </p>
//                 <p className="mb-4">
//                   The light above the table isn’t grand, but it’s quietly
//                   special, made with layered fabric, stitched by a local tailor
//                   who understood what we were trying to create.
//                 </p>
//                 <p className="mb-4">
//                   When the wind moves through, the light shifts just a little.
//                   It’s a space that feels open, gentle and lived in. Meals here
//                   tend to stretch longer than planned and that’s exactly how we
//                   like it.
//                 </p>
//               </div>
//             </div>

//             <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
//               <div
//                 className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto
//                             px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24
//                             mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
//               >
//                 <div className="flex flex-col justify-center items-start  space-y-4">
//                   <div className="text-right -ml-32">
//                     <h2
//                       className="text-[20px]
//                                   text-[#948A78] leading-snug mb-0 "
//                     >
//                       The Space at <br /> a Glance.
//                     </h2>
//                   </div>

//                   <div
//                     className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
//                                 text-[13px]
//                                 leading-relaxed  tracking-wide text-[#948A78]"
//                   >
//                     <p className="mb-0 mt-0">
//                       A 5-bedroom home with ensuite baths, vaulted living,
//                       sun-washed courtyards, a private pool, and an open-sky
//                       jacuzzi — designed for connection and calm.
//                     </p>
//                   </div>
//                   <div>
//                     <Link to="/OurSpaces">
//                       <span
//                         className="relative inline-block  tracking-widest uppercase cursor-pointer
//                                 text-[#948A78] text-[13px]
//                                 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                       >
//                         OUR SPACES
//                       </span>
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//               <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
//                 <div className="flex justify-end items-center mb-6 lg:mb-2">
//                   <span
//                     className="tracking-widest uppercase text-[#948A78]
//                       text-[13px]"
//                   >
//                     THE DINING ROOM
//                   </span>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3
//                                 transition-transform duration-300 hover:translate-x-1"
//                   >
//                     <path
//                       d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                       stroke="#948A78"
//                       strokeWidth="1.5"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>

//                 <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
//                   <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4a822b9a-c410-4eaa-e40e-48f0cc623000/public" //Tao_home_10.webp
//                           alt="living Detail 1"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>

//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1c12a187-829f-40d2-e80e-ad6a45dbc200/public" //Tao_home_11.webp
//                           alt="living Detail 2"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* -------- PANEL 3 -------- */}
//         <section
//           ref={registerPanel}
//           className="panel w-screen flex-shrink-0 flex items-center justify-center bg-[#f5f2f0] -mt-1 -ml-1"
//         >
//           <div
//             className="relative z-10 w-full flex flex-col md:flex-row bg-[#f5f2f0] pt-10 pb-10
//                             px-4 sm:px-6 md:px-10 lg:px-12 2xl:px-16 4k:px-32"
//           >
//             <div className="w-full md:w-[60%] flex flex-col items-start md:pl-10 lg:pl-16 4k:pl-28">
//               <div className="relative w-full max-w-[600px] 2xl:max-w-[1000px] mx-auto md:mx-0 mb-6 md:mb-10 lg:mb-12 2xl:mb-10 4k:mb-16">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3ab68105-6e37-41e5-3f1c-0fd16e867400/public" //Tao_home_12.webp
//                   alt="Living Room"
//                   className="
//                        lg:w-[400px] xl:w-[600px] 2xl:w-[80vh] 4k:w-[100vh]
//                        lg:h-[260px] xl:h-[380px] 2xl:h-[45vh] 4k:h-[50vh]
//                       object-cover shadow-lg transition-all duration-300"
//                 />
//                 <div
//                   className="absolute top-1/2 4k:-left-36 lg:-left-24 xl:-left-24 2xl:-left-24
//                               4k:bottom-40 2xl:-bottom-8 xl:-bottom-10 lg:-bottom-56
//                               transform -translate-y-1/2"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="text-[#948A78] mt-60 w-20 h-10 lg:w-24 lg:h-12 2xl:w-24 2xl:h-12 4k:w-36 4k:h-20"
//                   >
//                     <path
//                       d="M1 12.5H150M1 12.5l8-8M1 12.5l8 8"
//                       stroke="#948A78"
//                       stroke-width="1.0"
//                       fill="none"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </div>
//               </div>

//               {/* Bottom Left Text */}
//               <div
//                 className="lg:w-[98%] xl:w-[70%] 2xl:w-[520px] 4k:w-[550px]
//                             text-[13px]
//                             leading-relaxed  tracking-wide text-[#948A78]"
//               >
//                 <p className="mb-4">
//                   In a quiet corner, tea is brewed not for caffeine but for
//                   consciousness. The ritual is simple, almost sacred.
//                 </p>
//                 <p className="mb-4">
//                   Sip. Pause. Tap the table softly when the cup is empty, a
//                   gesture of thanks. The house honors Taoism, not through
//                   symbols, but through rhythm.
//                 </p>
//                 <p className="mb-4">
//                   Be here & now. <br />
//                   That’s the only rule. <br />
//                   That’s the only truth.
//                 </p>
//               </div>
//             </div>

//             <div className="w-full md:w-[40%] flex flex-col md:pl-6 mt-8 md:mt-0 4k:pr-28">
//               <div
//                 className="grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1200px] mx-auto
//                             px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 2xl:px-16 4k:px-24
//                             mb-12 md:mb-0 md:pt-7 gap-y-8 lg:gap-x-12"
//               >
//                 <div className="flex flex-col justify-center items-start  space-y-4">
//                   <div className="text-right -ml-32">
//                     <h2
//                       className="text-[20px]
//                                   text-[#948A78] leading-snug mb-0 "
//                     >
//                       The Space at <br /> a Glance.
//                     </h2>
//                   </div>

//                   <div
//                     className="lg:w-[300px] xl:w-[400px] 2xl:w-[400px] 4k:w-[400px]
//                                 text-[13px]
//                                 leading-relaxed  tracking-wide text-[#948A78]"
//                   >
//                     <p className="mb-0 mt-0">
//                       A 5-bedroom home with ensuite baths, vaulted living,
//                       sun-washed courtyards, a private pool, and an open-sky
//                       jacuzzi — designed for connection and calm.
//                     </p>
//                   </div>
//                   <div>
//                     <Link to="/OurSpaces">
//                       <span
//                         className="relative inline-block  tracking-widest uppercase cursor-pointer
//                                 text-[#948A78] text-[13px]
//                                 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                       >
//                         OUR SPACES
//                       </span>
//                     </Link>
//                   </div>
//                 </div>
//               </div>

//               <div className="self-end mt-auto w-full max-w-xs md:max-w-none 4k:max-w-full">
//                 <div className="flex justify-end items-center mb-6 lg:mb-2">
//                   <span
//                     className="tracking-widest uppercase text-[#948A78]
//                       text-[13px]"
//                   >
//                     Bedroom 01
//                   </span>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 160 25"
//                     className="ml-3 text-[#948A78] lg:w-20 lg:h-3 xl:w-20 xl:h-3 2xl:w-20 2xl:h-3 4k:w-20 4k:h-3
//                                 transition-transform duration-300 hover:translate-x-1"
//                   >
//                     <path
//                       d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                       stroke="#948A78"
//                       strokeWidth="1.5"
//                       fill="none"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>

//                 <div className="flex flex-col sm:flex-row sm:space-x-4 4k:space-x-6 space-y-4 sm:space-y-0 w-full max-w-[800px] mx-auto">
//                   <div className="flex flex-wrap sm:flex-nowrap gap-4 4k:gap-6 w-full">
//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a999cea9-fbbc-4eed-df8e-2eda6370cd00/public" //Tao_home_13.webp
//                           alt="living Detail 1"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>

//                     <div className="w-full sm:w-1/2">
//                       <div className="lg:h-[240px] xl:h-[390px] 2xl:h-[50vh] 4k:h-[650px]">
//                         <img
//                           src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/40614264-4460-4c41-5137-a36314e26c00/public" //Tao_home_14.webp
//                           alt="living Detail 2"
//                           className="w-full h-full object-cover shadow-lg"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* ---------- SECTION 8---------- */}
//       <div className="hidden lg:flex relative w-full min-h-screen items-center justify-center bg-[#f5f2f0] z-10 pt-16 -mb-10 -mt-1 py-0 md:py-1 pb-20 md:pb-10">
//         <div className="w-full h-[70vh] md:h-screen relative">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9cc21703-913d-4374-8fee-1b780d068b00/public"
//             alt="'IN SILENCE, EVERYTHING SPEAKS'"
//             className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] object-cover"
//           />

//           <div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-center">
//             <p
//               className="text-[#948A78] text-[13px] tracking-widest uppercase overflow-hidden whitespace-nowrap border-r-2 border-[#948A78]"
//               style={{
//                 width: "0ch",
//                 animation:
//                   "typing 2s steps(30) forwards, hideCursor 0.1s 2.2s forwards",
//               }}
//             >
//               IN SILENCE, EVERYTHING SPEAKS
//             </p>
//           </div>
//         </div>

//         <style jsx>{`
//           @keyframes typing {
//             from {
//               width: 0;
//             }
//             to {
//               width: 30ch;
//             }
//           }

//           /* Cursor disappear after typing */
//           @keyframes hideCursor {
//             to {
//               border-color: transparent;
//             }
//           }
//         `}</style>
//       </div>

//       {/* ---------- SECTION 9 --------- */}
//       <div
//         ref={addToRefs}
//         className="hidden lg:block relative w-full bg-[#f5f2f0] py-16 sm:py-20 lg:py-24 px-4 sm:px-8 md:px-12 lg:px-7 xl:px-28 2xl:px-40 4k:px-48 z-20 -mb-1"
//       >
//         <div className="flex flex-col lg:flex-row justify-between gap-12 xl:gap-24 4k:gap-36 4k:mt-28 4k:mb-44 xl:mb-28 lg:mb-24 ">
//           <div className="w-full lg:w-1/2 flex flex-col order-1 lg:order-1">
//             <h2 className="text-[20px]  tracking-wide text-[#948A78] mb-6 pb-0">
//               OUR SERVICES
//             </h2>

//             <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-16">
//               Curated experiences, thoughtfully delivered. At House of Tāo, our
//               in-house concierge service is here to enhance your stay with
//               curated experiences, local insights, and seamless planning — so
//               you can focus on unwinding.
//             </p>

//             <div className="w-full mt-8 sm:mt-10 mb-0 order-3 lg:order-1">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/73fff923-e47a-472f-0d24-f3cda7303500/public" //Tao_home_16.webp
//                 alt="Concierge services by the pool"
//                 className="w-[80vh] h-[55vh] object-cover"
//               />
//             </div>
//           </div>

//           <div className="w-full lg:w-1/2 flex flex-col justify-end items-end order-2 lg:order-2 4k:pl-40 4k:pr-16">
//             <div className="w-full 4k:max-w-[70%]">
//               <div className="4k:-ml-56 2xl:ml-4 xl:ml-6 lg:ml-0">
//                 <h2 className="text-[20px]  tracking-wide text-[#948A78] mb-2">
//                   What We Offer
//                 </h2>
//               </div>

//               <div className="4k:-ml-20 2xl:mr-10 2xl:w-[600px] xl:ml-44 lg:ml-16">
//                 <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-8">
//                   Our concierge can assist you with:
//                 </p>

//                 <div className="text-[#948A78] text-[13px] 4k:w-[690px] leading-relaxed  tracking-wide space-y-1 mb-10">
//                   <p>
//                     • Restaurant reservations at some of Goa’s best culinary
//                     spots
//                   </p>
//                   <p>• Private transfers & guided itineraries</p>
//                   <p>
//                     • Spa appointments, wellness sessions & yoga instructors
//                   </p>
//                   <p>• Decor for intimate celebrations</p>
//                   <p>• On-call chef experiences & wine/gin tastings</p>
//                   <p>• Yacht charters, beach picnics & cultural explorations</p>
//                 </div>

//                 <p className="text-[#948A78] text-[13px] lg:w-[450px] xl:w-[500px] 2xl:w-[500px] 4k:w-[500px] leading-relaxed  tracking-wide mb-24">
//                   All in-villa services (spa, setup, décor, etc.) must be booked
//                   through our concierge to ensure quality, safety, and
//                   consistency of service.
//                 </p>

//                 <p className="text-[#948A78] text-[13px] lg:w-[450px] xl:w-[500px] 2xl:w-[460px] 4k:w-[500px] leading-relaxed  tracking-wide mb-6">
//                   We’re here to ensure your stay is not only peaceful, but
//                   seamless — curated with care, hosted with intention. For any
//                   assistance, please reach out to your Villa Manager or
//                   Concierge Team directly during your stay.
//                 </p>
//               </div>

//               <div className="pt-2 4k:-ml-20 2xl:ml-44 2xl:w-[600px] xl:ml-44 lg:ml-16 mb-2">
//                 <Link to="/OurServices">
//                   <span
//                     className="relative inline-block  tracking-widest uppercase cursor-pointer text-[#948A78] text-[13px]
//                 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                   >
//                     explore our services
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ---------- SECTION 10 (LOCATION & SURROUNDINGS) ---------- */}
//       <div
//         ref={addToRefs}
//         className="hidden lg:block relative w-full bg-[#f5f2f0] py-6 sm:py-8 md:py-10 lg:py-16 xl:py-20 2xl:py-20 4k:py-20 px-4 lg:px-0 xl:px-0 2xl:px-0 4k:px-0 z-10 mt-0"
//       >
//         <div className="flex flex-col lg:flex-row justify-between items-stretch gap-10 xl:gap-16 2xl:gap-20 4k:gap-32">
//           <div className="w-full lg:w-1/3 flex flex-col justify-end lg:pl-20 xl:pl-28 2xl:pl-36 4k:pl-48 2xl:mr-0 lg:mr-20 4k:mr-20 pb-8 lg:pb-12">
//             <h2 className="text-[20px] uppercase  tracking-wide text-[#948A78] mb-8 lg:mb-12 mt-6 lg:mt-8">
//               Location & Surroundings
//             </h2>

//             <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-6">
//               A village where time moves a little slower. Parra has its own
//               pace: calm, familiar and quietly alive.
//             </p>

//             <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide mb-6">
//               It’s not where the parties are, but they’re not far either.
//               Beaches like Anjuna and Vagator, and the cafés of Assagao, are
//               just a short drive away.
//             </p>

//             <p className="text-[#948A78] text-[13px] leading-relaxed  tracking-wide">
//               That’s what makes this place special: it gives you room to
//               retreat, without losing touch with everything else.
//             </p>
//           </div>

//           <div className="w-full lg:w-2/3 mt-8 lg:mt-0 flex justify-end">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a7115959-dd6c-4d20-5748-93b0511af900/public"
//               alt="The spacious living room and staircase of the villa, looking out to the garden."
//               className="w-full max-w-[1000px] 2xl:max-w-[1000px] h-auto object-cover rounded-none shadow-none"
//             />
//           </div>
//         </div>
//       </div>
//       <div className="hidden lg:block">
//         <NewFooter />
//       </div>

//       {/* ------------------ MOBILE ------------------ */}
//       <div className="lg:hidden">
//         {/* SECTION 1 */}
//         <section
//           className="flex w-full h-screen flex-col items-center justify-center bg-cover bg-center relative z-0 mb-2"
//           style={{
//             backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a7115959-dd6c-4d20-5748-93b0511af900/public')`,
//             backgroundAttachment: "fixed",
//             backgroundPosition: "center",
//             backgroundSize: "cover",
//           }}
//         >
//           <div className="absolute inset-0 bg-black/50 z-0"></div>

//           <div className="fixed inset-0 flex flex-col items-center justify-center text-center text-[#F5F2F0] z-10">
//             <img
//               src="../assets/tao_logo_full.png"
//               alt="House of Tao"
//               className="w-[100px] lg:w-[130px] mt-2 animate-zoom-in"
//             />

//             <p className="absolute bottom-7 text-[13px] tracking-[0.20em] uppercase text-[#F5F2F0] text-center animate-slide-up">
//               WELCOME HOME,
//               <br /> TO YOURSELF
//             </p>
//           </div>
//         </section>

//         <style jsx global>{`
//           /* TEXT ANIMATION */
//           @keyframes slideUp {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           .animate-slide-up {
//             animation: slideUp 1s ease-out 1s forwards;
//           }

//           /* NEW SMALL → BIG ANIMATION */
//           @keyframes zoomInGrow {
//             0% {
//               opacity: 0;
//               transform: scale(0.7);
//             }
//             100% {
//               opacity: 1;
//               transform: scale(1);
//             }
//           }

//           .animate-zoom-in {
//             animation: zoomInGrow 1.2s ease-out forwards;
//           }
//         `}</style>

//         <NewHeader />

//         {/* SECTION 2 */}
//         <section
//           id="section2"
//           ref={addToRefs}
//           className="relative z-20 flex flex-col items-center w-full bg-[#f5f2f0] mt-0 mb-0"
//         >
//           <div className="flex justify-start w-full px-5">
//             <div className="relative w-[45vh] h-[45vh] sm:w-[85vh] sm:h-[60vh] -ml-5 overflow-hidden">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
//                 alt="Living Room"
//                 className="object-cover w-full h-full"
//               />
//             </div>
//           </div>
//           <div className="flex w-full justify-end px-5 py-8 md:items-start md:h-screen">
//             <div className="text-[#948A78] leading-[1.9] tracking-wide text-right space-y-2 mb-1 text-[13px] sm:mb-40">
//               <p>
//                 A space to pause, <br /> to feel the wind move <br /> through
//                 arches, <br /> to watch the light <br /> fall without urgency.
//               </p>
//               <p>
//                 Rooted in Taoist principles <br /> of balance and presence,{" "}
//                 <br /> our home is crafted to <br /> help you return to yours —{" "}
//                 <br /> the one within.
//               </p>
//               <p>
//                 Come as you are. <br /> Leave a little lighter.
//               </p>
//             </div>
//           </div>
//         </section>

//         {/* SECTION 3 */}
//         <div
//           ref={addToRefs}
//           className="relative z-20 flex w-full flex-col items-center justify-between bg-[#f5f2f0] pt-0 px-6 sm:px-20"
//         >
//           <div className="w-full flex justify-center mb-8 sm:-mt-40 mt-4 sm:ml-80 ml-10">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/07f16891-b0d9-4bc3-4a33-74c470751000/public" //Tao_home_3.webp
//               alt="Philosophy"
//               className="shadow-lg w-[55vh] h-[85vh] sm:w-[50vh] sm:h-[75vh] object-cover"
//             />
//           </div>
//           <div className="w-full sm:w-4/5 text-[#948A78] text-[12px] sm:text-[13px]  leading-[1.9] tracking-wide space-y-3 text-left relative">
//             <div className="flex justify-center mb-4 sm:mr-80 mr-52">
//               <h2 className="text-[20px]  text-[#948A78] text-right leading-snug">
//                 Our <br /> Philosophy
//               </h2>
//             </div>
//             <div className="space-y-3 text-left text-[13px] sm:ml-40 ml-14 w-[250px] sm:w-[350px]">
//               <p>
//                 House of Tao is designed to help you disconnect from noise and
//                 reconnect with what matters: nature, rest, and self.
//               </p>
//               <p>
//                 We follow Taoist principles: living in alignment with the
//                 natural world, choosing presence over pace and embracing the
//                 simple beauty of each moment.
//               </p>
//               <p>
//                 From the outside, it’s quiet and grounded. But step in and
//                 you’ll feel something shift — not because of grand gestures or
//                 luxury for luxury’s sake, but because every corner has been
//                 thought through.
//               </p>
//               <p>
//                 Here, beauty is not about perfection. It’s about presence — in
//                 the way light moves through a room, in how time begins to
//                 stretch, in how you begin to return to yourself.
//               </p>
//               <p>Welcome home. To yourself.</p>
//             </div>
//             <div className="text-[13px] flex justify-center items-center w-full mt-8 sm:-ml-8 -ml-9">
//               <a href="/OurPhilosophy">
//                 <p className=" tracking-widest uppercase text-[#948A78] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
//                   learn more
//                 </p>
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* SECTION 4 */}
//         <section
//           id="section4"
//           className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0]"
//         >
//           <div className="w-full flex justify-center mt-10">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e8195ab7-4494-4280-534c-cf52841a6d00/public" //Tao_home_5.webp
//               alt="Modern Architecture"
//               className="w-full h-auto object-cover transition-all duration-500"
//             />
//           </div>
//         </section>

//         {/* SECTION 5 */}
//         <section
//           id="section5"
//           ref={addToRefs}
//           className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] text-[#948A78] py-20"
//         >
//           <div className="flex flex-col items-start justify-center text-left max-w-sm sm:max-w-md px-8">
//             <div>
//               <h2 className="text-[20px] text-right mb-4 leading-snug sm:-ml-14">
//                 The Space at <br /> a Glance
//               </h2>
//             </div>
//             <p className="text-[13px] leading-relaxed mb-8 ml-28 sm:ml-20">
//               A 5-bedroom home with ensuite baths, vaulted living, sun-washed
//               courtyards, a private pool, and an open-sky jacuzzi — designed for
//               connection and calm.
//             </p>
//             <div className="flex items-center space-x-2 cursor-pointer group">
//               <Link to="/OurSpaces">
//                 <p className="text-[13px] tracking-[0.2em] uppercase  pb-[2px] text-[#948A78] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300 sm:ml-20 ml-28">
//                   our spaces
//                 </p>
//               </Link>
//             </div>
//           </div>
//         </section>

//         {/* ------------------ MOBILE CAROUSEL ------------------ */}
//         <div
//           className="flex w-full h-screen overflow-hidden"
//           ref={mobileCarouselRef}
//         >
//           {/* ---------------- PANEL 1 ---------------- */}
//           <div
//             ref={registerPanel}
//             className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
//           >
//             <div className="w-full flex flex-col items-center">
//               <div className="w-full flex justify-start">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/f17f87a3-4b3e-4cc0-4705-d03647d53700/public" //Tao_home_2.webp
//                   alt="Living Room Main"
//                   className="sm:w-[85vh] w-[50vh] sm:h-[60vh] h-[40vh] object-cover mb-10"
//                 />
//               </div>

//               <div className="flex justify-end items-center mb-6">
//                 <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-80 ml-16">
//                   THE LIVING ROOM
//                 </span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 160 25"
//                   className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
//                 >
//                   <path
//                     d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                     stroke="#948A78"
//                     strokeWidth="1.5"
//                     fill="none"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-72 ml-10  max-w-xs">
//                 This space is designed for pause.
//                 <br />
//                 For conversation.
//                 <br />
//                 For silence.
//                 <br />
//                 For everything in between.
//               </p>
//             </div>
//           </div>

//           {/* ---------------- PANEL 2 ---------------- */}
//           <div
//             ref={registerPanel}
//             className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
//           >
//             <div className="w-full flex flex-col items-center">
//               <div className="w-full flex justify-start">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/aa26ac68-9831-4885-8242-0f193f766000/public" //Tao_home_4.webp
//                   alt="Living & Dining"
//                   className="sm:w-[85vh] w-[50vh] sm:h-[60vh] h-[40vh] object-cover mb-10"
//                 />
//               </div>

//               <div className="flex justify-end items-center mb-6">
//                 <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-[70vh] ml-16">
//                   living & dining
//                 </span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 160 25"
//                   className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
//                 >
//                   <path
//                     d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                     stroke="#948A78"
//                     strokeWidth="1.5"
//                     fill="none"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-96 ml-24  w-[190px] sm:w-[200px]">
//                 Open-plan spaces with curated decor, blending modern design with
//                 Goan charm.
//               </p>
//             </div>
//           </div>

//           {/* ---------------- PANEL 3 ---------------- */}
//           <div
//             ref={registerPanel}
//             className="panel w-screen flex-shrink-0 flex flex-col items-center justify-center bg-[#f5f2f0] px-0 md:px-0 py-12"
//           >
//             <div className="w-full flex flex-col items-center">
//               <div className="w-full flex justify-start">
//                 <img
//                   src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3b1cca27-d5ae-4ef1-855c-1c97573c7300/public" //Tao_home_17.webp
//                   alt="The Pool & Jacuzzi"
//                   className="sm:w-[85vh] w-[50vh] sm:h-[60vh] h-[40vh] object-cover mb-10"
//                 />
//               </div>

//               <div className="flex justify-end items-center mb-6">
//                 <span className="text-[13px] tracking-widest uppercase text-[#948A78] sm:ml-[70vh] ml-16">
//                   the pool & jacuzzi
//                 </span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 160 25"
//                   className="ml-2 text-[#948A78] w-20 transition-transform duration-300 hover:translate-x-1"
//                 >
//                   <path
//                     d="M10 12.5H159M159 12.5l-8-8M159 12.5l-8 8"
//                     stroke="#948A78"
//                     strokeWidth="1.5"
//                     fill="none"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </div>
//               <p className="text-left text-[#948A78] text-[13px] leading-relaxed sm:ml-96 ml-24  w-[190px] sm:w-[200px]">
//                 A private retreat framed by greenery, perfect for a morning swim
//                 or an evening unwind.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ---------------- SECTION 9 ---------------- */}
//         <section
//           id="section9"
//           ref={addToRefs}
//           className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] py-10 lg:hidden"
//         >
//           <div className="sm:ml-[35vh] flex grid-cols-2 gap-1 w-full justify-center">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/80626821-ded1-416c-b3ce-80561ba7f300/public" //Tao_home_7.webp
//               alt="Cozy Reading Spot"
//               className="sm:w-[45vh] sm:h-[65vh] w-[30vh] h-[50vh] object-cover"
//             />
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
//               alt="Living Room Interior"
//               className="sm:w-[45vh] sm:h-[65vh] w-[30vh] h-[50vh] object-cover"
//             />
//           </div>
//         </section>

//         {/* ---------------- SECTION 10 ---------------- */}
//         <div className="flex lg:hidden relative w-full min-h-screen items-center justify-center bg-[#f5f2f0] z-10 pt-16 -mb-10 -mt-1 py-0 md:py-1 pb-20 md:pb-10">
//           <div className="w-full h-[70vh] md:h-screen relative">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9cc21703-913d-4374-8fee-1b780d068b00/public" //Tao_home_15.webp
//               alt="'IN SILENCE, EVERYTHING SPEAKS'"
//               className="w-full h-[100vh] lg:h-[100vh] xl:h-[110vh] 2xl:h-[100vh] 4k:h-[100vh] object-cover"
//             />
//             <div className="absolute left-0 right-0 bottom-0 text-center pb-0 md:pb-10">
//               <p className="text-[#948A78] text-[13px] tracking-widest uppercase -mb-16 ">
//                 IN SILENCE, EVERYTHING SPEAKS
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ---------------- SECTION 11 ---------------- */}
//         <section
//           id="section11"
//           ref={addToRefs}
//           className="py-10 bg-[#f5f2f0] relative z-20 lg:hidden"
//         >
//           <div className="max-w-6xl mx-auto px-4 sm:px-6 sm:mt-20">
//             <div className="text-left md:text-left md:max-w-2xl md:ml-80 ml-32">
//               <h2 className="text-[13px] tracking-[0.3em] uppercase text-[#948A78] mb-6">
//                 OUR SERVICES
//               </h2>
//               <p className="text-[13px] text-[#948A78] leading-relaxed">
//                 Curated experiences, thoughtfully delivered At House of Tāo, our
//                 in-house concierge service is here to enhance your stay with
//                 curated experiences, local insights, and seamless planning — so
//                 you can focus on unwinding.
//               </p>
//             </div>

//             <div className="mt-10 flex justify-start">
//               <div className="w-full max-w-4xl">
//                 <div className="relative w-[60vh] h-[60vh] sm:w-[85vh] sm:h-[60vh] -ml-6 overflow-hidden">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/73fff923-e47a-472f-0d24-f3cda7303500/public" //Tao_home_16.webp
//                     alt="Person relaxing in a pool under a decorative awning at House of Tāo"
//                     className="sm:w-[80vh] sm:h-[50vh] h-[58vh] w-[50vh] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ---------------- SECTION 12 ---------------- */}
//         <section
//           id="section12"
//           ref={addToRefs}
//           className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0] text-[#948A78] py-8 lg:hidden"
//         >
//           <div className="flex flex-col items-start justify-center text-left max-w-sm sm:max-w-md px-6 sm:px-8 space-y-4 sm:mr-80 mr-44">
//             <h2 className="text-[20px] mb-2 leading-snug">What We Offer</h2>
//           </div>

//           <div className="flex flex-col items-start text-[13px] justify-center text-left w-[320px] sm:w-[400px] px-6 sm:px-8 space-y-4 sm:ml-40 ml-16">
//             <p className="leading-relaxed">
//               Our concierge can assist you with:
//             </p>

//             <p className="leading-relaxed space-y-1">
//               • Restaurant reservations at some of Goa’s best culinary spots{" "}
//               <br />
//               • Private transfers & guided itineraries <br />
//               • Spa appointments, wellness sessions & yoga instructors <br />
//               • Decor for intimate celebrations <br />
//               • On-call chef experiences & wine/gin tastings <br />• Yacht
//               charters, beach picnics & cultural explorations
//             </p>

//             <p>
//               All in-villa services (spa, setup, décor, etc.) must be booked
//               through our concierge to ensure quality, safety, and consistency
//               of service.
//             </p>

//             <p>
//               We’re here to ensure your stay is not only peaceful, but seamless
//               — curated with care, hosted with intention. For any assistance,
//               please reach out to your Villa Manager or Concierge Team directly
//               during your stay.
//             </p>

//             <div className="flex items-center cursor-pointer group mt-4">
//               <Link to="/OurServices">
//                 <p className="text-[13px] tracking-[0.2em] uppercase pb-[2px] hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
//                   explore our services
//                 </p>
//               </Link>
//             </div>
//           </div>
//         </section>

//         {/* ---------------- SECTION 13 ---------------- */}
//         <section
//           id="section13"
//           ref={addToRefs}
//           className="relative z-20 flex lg:hidden flex-col items-center w-full bg-[#f5f2f0] mt-0 pb-10"
//         >
//           <div className="relative w-[65vh] h-[65vh] sm:w-[45vh] sm:h-[60vh] sm:mr-96 ml-10 overflow-hidden">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/0e4cf37d-ce81-4700-a923-f609d40c0500/public" //Tao_home_8.webp
//               alt="Living Room"
//               className="object-cover w-[45vh] h-[60vh] sm:w-[45vh] sm:h-[60vh]"
//             />
//           </div>

//           <div className="w-full px-5 mt-4">
//             <div className="text-[#948A78] leading-[1.9]  tracking-wide text-left space-y-2 text-[13px] sm:w-[350px] sm:ml-80 w-[200px] ml-24">
//               <p>
//                 Whether you’re planning your next getaway, looking for a special
//                 celebration venue, or simply curious to know more — we’d love to
//                 hear from you.
//               </p>
//               <Link to="/BookNow">
//                 <p className="text-[13px] tracking-[0.2em] uppercase pb-5 mt-5 hover:font-bold underline decoration-[#948A78] underline-offset-[8px] decoration-1 hover:underline-offset-[5px] transition-all duration-300">
//                   BOOK YOUR STAY
//                 </p>
//               </Link>
//             </div>
//           </div>
//         </section>
//         <div className="lg:hidden hidden:block">
//           <NewFooter />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;
